import React from "react";
import { getPlayerStatsDisplayData } from "../../@shared/utils/Utils";

const PlayerResultCard = ({ player, placement, matchData }) => {
  const stats = getPlayerStatsDisplayData(player, matchData);
  const isWinner = placement === 1;

  // Container styles (converted from React Native style object)
  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: isWinner ? "#1d183b" : "#141225",
    border: `${isWinner ? 2 : 1}px solid ${isWinner ? "#fbcf57" : "#333"}`,
    padding: "14px",
    borderRadius: "14px",
    margin: "6px 8px",
    width: "90%",
    boxShadow: isWinner
      ? "0px 2px 10px rgba(251, 207, 87, 0.6)"
      : "0px 2px 4px rgba(0, 0, 0, 0.3)",
  };

  // Avatar image style
  const avatarStyle = {
    width: "60px",
    height: "60px",
    borderRadius: "30px",
    border: isWinner ? "2px solid #fbcf57" : "none",
    marginRight: "14px",
    objectFit: "cover",
  };

  // Player info container style
  const infoContainerStyle = {
    flex: 1,
  };

  // Text style objects
  const nameStyle = {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    margin: 0,
  };

  const placementStyle = {
    color: "#bbb",
    fontSize: "14px",
    margin: "4px 0",
  };

  const eliminationsStyle = {
    color: "#fbcf57",
    fontSize: "14px",
    margin: "4px 0",
  };

  const movesStyle = {
    color: "#aaa",
    fontSize: "13px",
    margin: "4px 0",
  };

  return (
    <div style={containerStyle}>
      {/* Avatar */}
      <img src={stats.avatar} alt="avatar" style={avatarStyle} />

      {/* Player Info */}
      <div style={infoContainerStyle}>
        <p style={nameStyle}>
          {isWinner ? "👑 " : ""}
          {player.name}
        </p>
        <p style={placementStyle}>Placement: #{placement}</p>
        <p style={eliminationsStyle}>
          🔪 Eliminations: {stats.eliminationsCount}
        </p>
        <p style={movesStyle}>🎲 Moves: {stats.movesCount}</p>
      </div>
    </div>
  );
};

export default PlayerResultCard;
